export type Amenagement = {
  title: string;
  text: string;
  href: string;
  image: string;
  alt: string;
};

export const featuredAmenagement: Amenagement = {
  title: "Aménagement complet",
  text: "Du plancher au plafond : isolation, mobilier bois, cuisine, couchage et électricité. Un intérieur pensé pour votre façon de voyager.",
  href: "/amenagements/complet",
  image: "https://cdn.magicpatterns.com/patterns/generated-images/0141854e-9c2b-41c4-86f9-467d31f4b815.jpg",
  alt: "Intérieur de van aménagé en bois clair avec cuisine et banquette",
};

export const amenagements: Amenagement[] = [
  {
    title: "Banquette-lit",
    text: "Banquettes homologuées qui se transforment en lit douillet.",
    href: "/amenagements/banquette-lit",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/b295da37-4159-45b3-ac28-3d436c74440d.jpg",
    alt: "Banquette-lit grise avec ceintures dans un van",
  },
  {
    title: "Toit relevable",
    text: "Deux couchages en plus et une hauteur debout, en un geste.",
    href: "/amenagements/toit-relevable",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/8d7551da-c433-4ffc-93f4-d81765071fa5.jpg",
    alt: "Van avec toit relevable face à l'océan au coucher du soleil",
  },
  {
    title: "Mobilier & cuisine",
    text: "Meubles sur mesure et cuisine fonctionnelle, même dans 3 m².",
    href: "/amenagements/mobilier",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/0c37aec1-7073-438d-b8a9-cc78cc1fdd31.jpg",
    alt: "Bloc cuisine en bois à l'arrière d'un van",
  },
];
